import React from 'react';
import { Modal, CloseButton } from '@landing/ui';
import { observer, modal as modalStore } from 'store';

function PostSendModal({ className, Icon, children, modalID, theme = 'send' }) {
  const isOpen = modalStore.modalID === modalID;
  const modalProps = modalStore.modalProps;

  const Children = typeof children === 'function' ? children : () => children;

  return (
    <Modal
      className={className}
      isOpen={isOpen}
      closeButton={false}
      animation="opacity"
      closeModalCallback={modalStore.close}
      theme={theme}
    >
      {onClose => (
        <>
          {Icon && <Icon />}
          <CloseButton
            onClose={() => {
              onClose();
              modalStore.close();
            }}
          />
          {Children(modalProps)}
        </>
      )}
    </Modal>
  );
}

export default observer(PostSendModal);
